import {Base} from '@/dto/Base';
import {KsChatUser} from "@/entity/KsChatUser";
import {InsertGroup} from "@/entity/InsertGroup";
import {Response} from "@/entity/Response";
import {KsManager} from "@/entity/KsManager";

export class KsChatUserDto {

    //获取用户的所有群聊
    public static async getchatuser(userId: string) {
        const response = await Base.getDataWithJwt('/ksuser/getchatuser', {userId});
        return response.data as KsChatUser[];
    }

    //创建群聊
    public static async insertGroup(insertGroup: InsertGroup) {
        const response = await Base.postWithToken('/ksgroup/insertGroup', insertGroup);
        return response as Response;
    }

    //删除群聊
    public static async deleteKsGroup(groupId: number) {
        const response = await Base.getDataWithJwt('/ksgroup/deleteKsGroup', {groupId});
        console.log(response)
        return response as Response;
    }

    //获取群聊所有成员
    public static async getallUserBygroupId(groupId: string) {
        const response = await Base.getDataWithJwt('/ksgroup/getallUserBygroupId', {groupId});
        return response.data as KsChatUser[];
    }

    //获取群聊详细信息
    public static async getksgroup(id: string) {
        const response = await Base.getDataWithJwt('/ksgroup/getksgroup', {id});
        return response[0] as KsChatUser;
    }

    //删除群聊成员
    public static async deletechatuser(ksChatUser: KsChatUser) {
        const response = await Base.postWithToken('/ksuser/deletechatuser', ksChatUser);
        return response as Response;
    }

    //新增群聊成员
    public static async insertchatuser(ksChatUser: KsChatUser) {
        const response = await Base.postWithToken('/ksuser/insertchatuser', ksChatUser);
        return response as Response;
    }

    //获取某群的群主以及管理员信息
    public static async getmanagermessage(groupId: string) {
        const response = await Base.getDataWithJwt('/ksgroup/getmanagermessage', {groupId});
        return response.data as KsManager[];
    }

    //新增管理员
    public static async insetksmanger(ksManager: KsManager) {
        const response = await Base.postWithToken('/ksmanger/insetksmanger', ksManager);
        console.log(response)
        return response as any;
    }

    //修改管理员
    public static async updateksmanger(ksManager: KsManager) {
        const response = await Base.postWithToken('/ksmanger/updateksmanger', ksManager);
        console.log(response)
        return response as any;
    }

    //删除管理员
    public static async deleteksmanger(ksManager: KsManager) {
        const response = await Base.postWithToken('/ksmanger/deleteksmanger', ksManager);
        console.log(response)
        return response as Response;
    }
}
